// eslint-disable-next-line no-unused-vars
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getConfiguration } from '../Reducers/Configuration/Actions';
import { loadOptions } from '../Reducers/Option/Actions';
import { globalLoaderStateManager } from '../GlobalLoader';

const { watchPromise } = globalLoaderStateManager;

export const useLoadConfiguration = () => {
  const dispatch = useDispatch();
  const { configuration } = useSelector((state) => state.Configuration);
  const { componentOptions } = useSelector((state) => state.Option);

  useEffect(() => {
    watchPromise(dispatch(getConfiguration()));
  }, [dispatch]);

  useEffect(() => {
    if (configuration.code) {
      componentOptions.map(
        (classification) =>
          classification.options.length === 0 &&
          watchPromise(dispatch(loadOptions(classification.key, classification.identifier, configuration)))
      );
    }
  }, [configuration, dispatch]);

  return { configuration };
};
